export const HOURS_TIME_LIST = Array(24)
  .fill(undefined)
  .map((_, index) => (index < 10 ? `0${index}:00` : `${index}:00`));
